export default __webpack_public_path__ + "static/media/bg-polipromotion.19b6bffe.jpg";